<template>
  <LayoutHeader main="google" ref="layout" :loadingOverlay="loadingOverlay" :me="me" :lastApp="lastApp" :appHistory="appHistory">
    <article v-if="google">
      <h1 class="text-center mb-5">Google ログイン連携設定</h1>

      <h3 class="mb-2 fs-5">連携状態</h3>
      <div class="mb-5">
        <div class="rounded bg-white p-4 d-flex justify-content-between" v-if="google.email">
          <div class="d-flex align-items-center text-dark">連携済み：{{ google.email }}</div>
          <div>
            <button class="btn btn-outline-dark" @click="unlinkGoogle()">連携を解除</button>
          </div>
        </div>
        <div class="rounded bg-white p-4 d-flex justify-content-between" v-else>
          <div class="d-flex align-items-center text-dark">
            未連携
          </div>
          <div>
            <a class="btn btn-outline-dark" href="/player/google/link">連携する</a>
          </div>
        </div>
      </div>

      <div class="mb-5 text-center">
        <router-link class="text-decoration-underline" :to="{ name: 'Account' }">戻る</router-link>
      </div>
    </article>

    <Modal v-model="linkedModal" title="連携が完了しました">
      <div class="text-center">
        <div class="mb-3">
          <div class="alert alert-success">
            Google 連携が完了しました。
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-dark" @click.prevent="linkedModal = false">閉じる</button>
        </div>
      </div>
    </Modal>

    <Modal v-model="alreadyModal" title="連携に失敗しました">
      <div class="text-center">
        <div class="mb-3">
          <div class="alert alert-danger">
            別のアカウントと連携済みなため、連携できませんでした。
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-dark" @click.prevent="alreadyModal = false">閉じる</button>
        </div>
      </div>
    </Modal>

    <Modal v-model="unlinkedModal" title="連携を解除しました">
      <div class="text-center">
        <div class="mb-3">
          <div class="alert alert-success">
            Google 連携を解除しました。
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-dark" @click.prevent="unlinkedModal = false">閉じる</button>
        </div>
      </div>
    </Modal>

    <Modal v-model="noPasswordModal" title="パスワードを登録して下さい">
      <div class="text-center">
        <div class="mb-3 mt-2">
          連携を解除するには、パスワードの登録が必要です。
        </div>
        <div>
          <router-link class="btn btn-dark" :to="{ name: 'Password' }">パスワードを登録する</router-link>
        </div>
      </div>
    </Modal>
  </LayoutHeader>
</template>

<script>
import baseMixin from './base'

export default {
  mixins: [
    baseMixin,
  ],
  data () {
    return {
      titlePrefix: 'Google ログイン連携設定',
      google: null,
      noPasswordModal: false,
      linkedModal: false,
      alreadyModal: false,
      unlinkedModal: false,
      email: this.$route.query.email || '',
    }
  },
  methods: {
    _mounted() {
      this.axios({
        url: '/google',
        method: 'get',
      }).then(res => {
        this.google = res.data.google;
      });
    },
    _meSeted(me, session) {
      if (session && session.flash == 'already') {
        this.alreadyModal = true;
      }
      if (session && session.flash == 'linked') {
        this.linkedModal = true;
      }
    },
    unlinkGoogle() {
      if (!confirm('連携を解除してもよろしいですか？')) {
        return;
      }
      this.loadingOverlay = true;
      this.axios({
        url: '/google/unlink',
        method: 'post',
      }).then(res => {
        this.loadingOverlay = false;
        if (!res.data) {
          this.noPasswordModal = true;
          return;
        }
        this.google = {};
        this.unlinkedModal = true;
      });
    },
  },
}
</script>
